import Logo from "../../Assets/Images/AccountingLogo.svg";

export default function ModalBody(props) {
  return (
    <div className="modal-body tabulator-modal-body">
      {props.children}
      {/*<img className="btm-logo" src={Logo} alt=""/>*/}
      {/* <div className={'w-100 text-start'}>
        <div className={'ravanhesabText'}>
          <div>Ravan</div>&nbsp;<div className={'Hesab'}>Hesab</div>
        </div>
        <div className={'ravanhesabDescription'}>Accounting and management software</div>
      </div> */}
    </div>
  );
}
